import React from 'react'
import styled from 'styled-components'
import { Col, Row, Container } from 'react-bootstrap'
import Text from '../shared/Text'
import { Stars } from '../shared/Stars'
import styles from '../../utility/styles'
import PopularTimesChart from './PopularTimesChart'

const Wrapper = styled.div`
	border-bottom: 1px solid var(--tz-hairline, rgba(255, 255, 255, 0.08));
	padding-bottom: 38px;
`

const StyledRow = styled(Row)``

const StyledCol = styled(Col)`
	border-left: ${({ border }) =>
		border ? `1px solid var(--tz-hairline, rgba(255, 255, 255, 0.08))` : 'none'};
	@media only screen and (max-width: 768px) {
		// based on a md={5} breakpoint!
		border: none;
	}
`

const MyRow = styled.div`
	display: flex;
	align-items: center;
`

const MyCol = styled.div`
	display: flex;
	flex-direction: column;
`

const ReviewWrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin-left: 24px;
	@media only screen and (max-width: 768px) {
		// based on a md={5} breakpoint!
		margin-left: 0;
		margin-top: 24px;
	}
`

const RatingsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	flex: 1;
	@media only screen and (max-width: 768px) {
		// based on a md={5} breakpoint!
		margin-left: 24px;
	}
`

/**
 *
 * @param {{
 *   popularTimes:{day:number,day_string:string,is_current_day:boolean,vals:any}[],
 *   ratings:{c:string,v:number,r:number}[]
 * }} props
 * @returns
 */
export default function PopularSection({ popularTimes = [], ratings = [] }) {
	const ratingsInternal = React.useMemo(
		() => ratings.filter(({ c }) => c !== 'SC_TOTAL'),
		[ratings]
	)
	// Near-zero utilization renders a garbage chart (1e-10% axis labels);
	// under half a percent across every day counts as "no data".
	const hasPopularTimes = React.useMemo(
		() => popularTimes.some(d => Object.values(d?.vals ?? {}).some(v => Number(v) >= 0.5)),
		[popularTimes]
	)
	if (!hasPopularTimes && !ratingsInternal.length) return null
	return (
		<Wrapper>
			<Container>
				<StyledRow>
					{hasPopularTimes && (
						<StyledCol md={7}>
							<Text.Heading type='h5' variant='bold'>
								Popular Times
							</Text.Heading>
							<PopularTimesChart {...{ popularTimes }} />
						</StyledCol>
					)}
					<StyledCol md={hasPopularTimes ? 5 : 12} border={hasPopularTimes}>
						<ReviewWrapper>
							<Text.Heading
								type='h5'
								variant='bold'
								style={{ flex: 0, marginBottom: '12px' }}
							>
								Reviews
							</Text.Heading>
							<RatingsWrapper>
								{ratingsInternal?.map(({ c, v, r }) => (
									<MyCol key={c}>
										<Text.Body variant='bold'>
											{c}
										</Text.Body>
										<MyRow>
											<Stars
												scale={0.7}
												uuid={c.split(' ').join('')}
												ratings={v}
												outOf={5}
											/>
											<Text.Tiny
												color={styles.colors.lightGray}
												style={{ marginLeft: '4px' }}
											>
												{r} Responses
											</Text.Tiny>
										</MyRow>
									</MyCol>
								))}
							</RatingsWrapper>
						</ReviewWrapper>
					</StyledCol>
				</StyledRow>
			</Container>
		</Wrapper>
	)
}
